export enum ChatbotGenericEvents {
	OPEN_CHATBOT = 'open_chatbot',
}
